import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column flex-column-fluid bgi-position-y-center position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed",
  style: {"background-image":"url('media/illustrations/progress-hd.png')"}
}
const _hoisted_2 = { class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20" }
const _hoisted_3 = { class: "w-lg-500px  bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "text-center mb-10  p-8 rounded" }, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "mb-12"
  }, [
    /*#__PURE__*/_createVNode("img", {
      alt: "Logo",
      src: "media/logos/Cabecera-sistena.png",
      class: "h-50px"
    })
  ])
], -1)
const _hoisted_5 = { class: "fv-row mb-10" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { class: "form-label fs-6 fw-bolder text-dark" }, "Email", -1)
const _hoisted_7 = { class: "fv-plugins-message-container" }
const _hoisted_8 = { class: "fv-help-block" }
const _hoisted_9 = { class: "fv-row mb-10" }
const _hoisted_10 = { class: "d-flex flex-stack mb-2" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bolder text-dark fs-6 mb-0" }, "Password", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Forgot Password ? ")
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn btn-lg btn-danger w-100 mb-5",
  style: {"background-color":"#eb1b22"}
}
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, " Continue ", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-center flex-column-auto p-10\"><div class=\"d-flex align-items-center fw-bold fs-6\"><a href=\"#\" class=\"text-muted text-hover-primary px-2\">About</a><a href=\"#\" class=\"text-muted text-hover-primary px-2\">Contact</a><a href=\"#\" class=\"text-muted text-hover-primary px-2\">Contact Us</a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          class: "form w-100",
          id: "kt_login_signin_form",
          onSubmit: _ctx.onSubmitLogin,
          "validation-schema": _ctx.login
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid",
                type: "text",
                name: "email",
                autocomplete: "off"
              }),
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_ErrorMessage, { name: "email" })
                ])
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_router_link, {
                  to: "/password-reset",
                  class: "link-primary fs-6 fw-bolder"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid",
                type: "password",
                name: "password",
                autocomplete: "off"
              }),
              _createVNode("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode(_component_ErrorMessage, { name: "password" })
                ])
              ])
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode("button", _hoisted_16, [
                _hoisted_17,
                _hoisted_18
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ]),
    _hoisted_19
  ]))
}